var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.0206 81.1283L44.4999 88L18.9788 81.1283L13.0896 17.3264H75.9106L70.0206 81.1283Z",
    fill: "#2062AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4991 22.4942V82.519L44.5569 82.5347L65.2098 76.9734L69.9769 22.4942H44.4991Z",
    fill: "#3C9CD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.015 7.95282V4.15534H35.5555V0H25.8596V11.7447H35.5555V7.95282H30.015ZM45.5223 4.15534H49.3958V0H39.699V4.15534C40.9963 5.45264 41.6729 6.07356 43.5491 7.94982C42.4523 7.94982 39.699 7.95375 39.699 7.95356V11.7447H49.3958V7.95282L45.5223 4.15534ZM59.2657 4.15534H63.1391V0H53.4419V4.15534C54.7392 5.45264 55.4161 6.07356 57.2924 7.94982C56.196 7.94982 53.4419 7.95375 53.4419 7.95356V11.7447H63.1393V7.95282L59.2657 4.15534Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4764 38.4474L26.2104 46.0547L26.8162 53.5865L44.4764 46.0356L63.2623 38.0038L64.0412 30.299L44.4764 38.4474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2104 46.0545L26.8162 53.5863L44.4765 46.0354V38.4473L26.2104 46.0545Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0412 30.299L44.4763 38.4472V46.0354L63.2623 38.0035L64.0412 30.299Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2385 46.0547L26.8445 53.5865L53.9418 53.6729L53.3357 63.7152L44.4191 66.2255L35.8476 64.0613L35.3282 57.8281H27.3638L28.4028 69.8615L44.5056 74.6227L60.5212 69.9478L62.5991 46.0547H26.2385Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M44.4765 46.0547H26.2104L26.8162 53.5865L44.4765 53.6429V46.0547ZM44.4765 66.2015L44.3899 66.2257L35.8196 64.0614L35.3002 57.8282H27.3359L28.3747 69.8616L44.4765 74.6229V66.2015Z",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5652 30.299H64.0412L63.2623 38.0037H25.5174L24.5652 30.299Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M44.4762 30.299H24.5652L25.5174 38.0037H44.4762V30.299Z",
    fill: "#101010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 35.3435,
    y1: 53.5865,
    x2: 35.3435,
    y2: 38.4475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#D1D3D4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D3D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 54.2585,
    y1: 46.0356,
    x2: 54.2585,
    y2: 30.2991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#D1D3D4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D3D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 26.2385,
    y1: 60.3389,
    x2: 62.5989,
    y2: 60.3389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 24.5652,
    y1: 34.1513,
    x2: 64.041,
    y2: 34.1513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.d332a9166f4f73dca7963e78ba278683.svg";
export { ForwardRef as ReactComponent };